import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone,<br /> I am <span className="purple">Christian Cook </span>
            from <span className="purple"> Hillsborough NC. </span>
            <br /> As a senior architect, I have deep experience in this field.
            <br />
            Additionally, now I am free and looking for a job opportunity.
            <br />
            <br />
            Apart from architecture, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing literal works
            </li>
            <li className="about-activity">
              <ImPointRight /> Hiking or Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "What could we do with our hands.
            <br /> To our oriented future, for our new coming generation."{" "}
          </p>
          <footer className="blockquote-footer">Chris</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
